<template>
    <div class="contents">
      <div class="wrap">
        <section>
          <h2 class="page_title --view">QnA 답변 등록</h2>
        </section>
        <section class="view">
          <div class="table_list">
            <table class="write">
              <colgroup>
                <col width="200">
                <col width="*">
              </colgroup>
              <tbody>
                <tr>
                  <th><span>제목</span></th>
                  <td>{{qnaInfo.qna_title}} </td>
                </tr>
                <tr>
                  <th><span>작성자</span></th>
                  <td>{{qnaInfo.doctor_nm}}</td>
                </tr>
                <tr>
                  <th><span>내용</span></th>
                  <td>
                    <pre>{{qnaInfo.question_contents}}</pre>
                  </td>
                </tr>
                <tr>
                  <th><span>답변</span></th>
                  <td>
                    <textarea class="form_control" style="line-height: 20px;" v-model="qnaInfo.response_contents"></textarea>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="bottom_box">
              <button class="btn btn_md btn_outline" @click="fn_move_listPage">목록</button>
              <div class="btn_box">
                <!-- <button class="btn btn_md btn_gray"  @click="fn_move_listPage">취소</button> -->
                <button class="btn btn_md btn_darkblue" @click="fn_qna_vailidation">저장</button>
              </div>
            </div>
          </div>
        </section>
      </div>
      <alert-modal 
        :id="'alert'"
        :text="showAlertMsg" 
        :btnRight="'확인'" 
        :oneBtn="false"
        :isShow="showAlert"
        :className="'btn_brown'"
        :closeEventValue="closeEventValue"
        @closeEvent="oncCloseEvent"
        v-on:update:showSetting="fn_showSet"
        />
    </div>
</template>

<script>
  import axios from 'axios'
  import AlertModal from "@/modal/common/alertModal.vue"
  import alertutill from "@/mixin/alertModalUtill";  

  export default {
    name: 'QnaWrite',
    props: ['id'],
    components: {
      'alert-modal' : AlertModal,
    },
    mixins: [alertutill],
    data() {
      return {
        qnaInfo : {},
        selected: null,
      }
    },
    mounted(){
      this.fn_search();
    },
    methods : {
        fn_search(){

            let param = new Object();
            console.log("@@@@ id : "+this.id);
            param.qnaSeq = this.id;

            axios
                .post("/api/admin/board/getQnaInfo", param)
                .then((res) => {

                    this.qnaInfo = res.data.qnaInfo;

                    console.log("@@@@ qnaInfo : %o",this.qnaInfo);                      

                })
                .catch((err) => console.log(err));
        },
        fn_qna_vailidation(){
          if(this.qnaInfo.response_contents == ''){
              let msg = "답변이 등록되지 않았습니다.";
              this.fn_open_alert(msg); 
              return false;
          }

          this.fn_qna_reg();

      },
      fn_qna_reg(){
      
        console.log("@@@@ qnaInfo : %o",this.qnaInfo);
        axios
          .post("/api/admin/board/regQnaResponse", this.qnaInfo)
          .then((res) => {                            
              console.log("@@@@ res : %o",res);

              let msg = "저장되었습니다.";
              this.fn_open_alert_close(msg);
              
              
          })
          .catch((err) => console.log(err));
      },
      fn_move_listPage(){
          this.$router.push("/admin/board/qnaMngt");
      },
      oncCloseEvent(){
          this.fn_move_listPage();
      }
    }
  }
</script>